"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class AuthApi {
    constructor(api) {
        this.api = api;
        this.api.axiosGo.interceptors.response.use(data => data, (error) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            this.api.logError(error);
            console.log('[Axios][Interceptor] Response Error', error);
            const res = error.response;
            if ((res === null || res === void 0 ? void 0 : res.status) === 406 && ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.error) === 'token expired') {
                if (this.api.refresh != null) {
                    if (this.api.updateUserCallback != null) {
                        const user = yield this.refresh(this.api.refresh);
                        this.api.updateUserCallback(user, error);
                        if (error.config != null) {
                            error.config.headers.Authorization = this.api.axiosGo.defaults.headers.common.Authorization;
                            return yield this.api.axiosGo.request(error.config);
                        }
                    }
                }
            }
            else if ((res === null || res === void 0 ? void 0 : res.status) === 401) {
                if (this.api.resetUserCallback != null) {
                    this.api.resetUserCallback(String((_c = (_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.error) !== null && _c !== void 0 ? _c : res === null || res === void 0 ? void 0 : res.status), error);
                    return yield Promise.reject(error);
                }
            }
            return yield Promise.reject(error);
        }));
        this.api.axiosNode.interceptors.response.use(data => data, (error) => __awaiter(this, void 0, void 0, function* () {
            var _d, _e, _f, _g, _h;
            this.api.logError(error);
            console.log('[Axios][Interceptor] Response Error', error);
            const res = error.response;
            if ((res === null || res === void 0 ? void 0 : res.status) === 500 && ((_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.message) === 'UnauthorizedError: jwt expired') {
                if (this.api.refresh != null) {
                    if (this.api.updateUserCallback != null) {
                        const user = yield this.refresh(this.api.refresh);
                        this.api.updateUserCallback(user, error);
                        if ((error === null || error === void 0 ? void 0 : error.config) != null) {
                            error.config.headers.Authorization = this.api.axiosNode.defaults.headers.common.Authorization;
                            return yield this.api.axiosNode.request(error.config);
                        }
                    }
                }
            }
            else if ((res === null || res === void 0 ? void 0 : res.status) === 401) {
                if (this.api.resetUserCallback != null) {
                    this.api.resetUserCallback(String((_h = (_f = (_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.error) !== null && _f !== void 0 ? _f : (_g = res === null || res === void 0 ? void 0 : res.data) === null || _g === void 0 ? void 0 : _g.message) !== null && _h !== void 0 ? _h : res === null || res === void 0 ? void 0 : res.status), error);
                    return yield Promise.reject(error);
                }
            }
            return yield Promise.reject(error);
        }));
    }
    /**
     * 修改角色權限
     */
    updateUserScope(username, scopes) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/user/cred/scope';
            const data = { username, scopes };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 餐廳登入
     */
    login(username, password, deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/user/login';
            const data = { username, password, deviceId };
            const response = yield this.api.axiosGo.post(endpoint, data);
            this.api.setToken(response.data.token, response.data.refresh);
            return response.data;
        });
    }
    /**
     * 角色登入
     */
    scopeLogin(username, password, deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/user/scopelogin';
            const data = { username, password, deviceId };
            const response = yield this.api.axiosGo.post(endpoint, data);
            this.api.setToken(response.data.token, response.data.refresh);
            return response.data;
        });
    }
    /**
     * 角色登入 (不設定 token)
     */
    scopeLoginWithOutSetToken(username, password, deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/user/scopelogin';
            const data = { username, password, deviceId };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * @deprecated 目前沒有專案使用
     */
    scopeLoginWithMerchantAccount(username, password, merchantUsername) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/user/scopelogin/${merchantUsername}`;
            const data = { merchantUsername, username, password };
            const response = yield this.api.axiosGo.post(endpoint, data);
            this.api.setToken(response.data.token, response.data.refresh);
            return response.data;
        });
    }
    /**
     * 系統管理員登入
     */
    adminLogin(password) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/user/scopelogin/admin';
            const data = { password };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    refresh(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/user/refresh';
            const data = { token };
            const response = yield this.api.axiosGo.post(endpoint, data);
            this.api.setToken(response.data.token, response.data.refresh);
            return response.data;
        });
    }
    /**
     * 新增角色
     * 或修改角色密碼
     */
    updateUser(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/user/cred';
            const data = { username, password };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
    /**
     * 取得餐廳登入資料
     */
    getUserInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/user/info';
            const response = yield this.api.axiosGo.get(endpoint);
            return response.data;
        });
    }
    /**
     * 刪除角色帳號
     */
    deleteUser(username) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/user/cred/${username}`;
            const response = yield this.api.axiosGo.delete(endpoint);
            return response.data;
        });
    }
}
exports.default = AuthApi;
//# sourceMappingURL=Auth.js.map